<template>
  <div class="container">
    <div class="top_title"><router-link class="icon_back" :to="{name:'H300010'}" tag="span"></router-link>
      学员二维码详细</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="student_info_title" style="margin-top: 2.6rem">
        <span class="icon_student_info"></span>
        <span>学员信息</span>
      </div>
      <div class="student_items">
        <div class="weui-cells item">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>校区</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_SCHOOL_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>班级</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_CLASS_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>姓名</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_STUDENT_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>手机</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_TEL" />
            </div>
          </div>
        </div>
      </div>

      <div class="QRcode_info_title">
        <span class="icon_QRcode_info"></span>
        <span>二维码</span>
      </div>
      <div class="QRcode_aera">
        <img :src="info.I_QR_URL" />
        <p>{{info.I_INFO}}</p>
      </div>

      <router-link :to="{name:'H300010',params:{pageNo: 'H300020'}}" tag="button" class="bottom_btn">返回</router-link>
    </div>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        info: {}
      }
    },
    created() {
      let H300020Info = this.$route.params.info
      if(H300020Info) {
        H300020Info = JSON.parse(H300020Info)
        window.localStorage.setItem("H300020", JSON.stringify(H300020Info))
      } else {
        H300020Info = JSON.parse(window.localStorage.getItem("H300020"))
      }

      DataRequestFactory.I300020(H300020Info).then((response) => {
        this.info = response
    })
    },
    methods: {
      gotoPre() {

      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 0
      $(".scroll_area").css("height", heightDiff + "px"   )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H300020.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H300020.vue